import React, { Component } from 'react';
import { NavLink, withRouter } from "react-router-dom"
import { authentication } from '../../services/Authentication';
//import { history } from '../History';
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import "react-datepicker/dist/react-datepicker.css";
import HeaderTab from "./Header";

class Header extends Component {
    constructor(props) {
        super(props);

        const { name, user_type, user_permission } = authentication.currentUserValue;

        this.state = {
            name: name,
            user_type: user_type,
            logoutIsOpen: false,
            user_permission: user_permission,
            currentPage: ``,
            matches: window.matchMedia("(min-width: 768px)").matches
        }
        //console.log("*******"+JSON.stringify(authentication));
        this.LogoutSubmit = this.LogoutSubmit.bind(this);
        this.closeLogoutCancel = this.closeLogoutCancel.bind(this);
        this.openLogoutCancel = this.openLogoutCancel.bind(this);
    }

    componentDidMount() {
        this.setState({ currentPage: this.props.location.pathname });
        const handler = e => this.setState({ matches: e.matches });
        window.matchMedia("(min-width: 768px)").addListener(handler);
    }

    LogoutSubmit() {
        authentication.logout();
        //history.push('/login');
    }

    closeLogoutCancel() {
        this.setState({ logoutIsOpen: false });
    }

    openLogoutCancel() {
        this.setState({ logoutIsOpen: true });
    }

    render() {
        var dnow = new Date();
        var strname = moment(dnow).format('DD/MM/YYYY H:mm น.')
        return (<div>
            <div className="content-header" style={{ padding: '0px' }}>
                <div className="container-fluid">
                    {this.state.matches && (<div className="row">
                        <div className="col-sm-6">
                            <ul className="float-sm-left tabmenu">
                                {/* {(this.state.user_permission[251].permission == 1 &&
                                    <NavLink exact to="/my-case" activeClassName="active">
                                        <li>My Case</li>
                                    </NavLink>
                                )} */}

                                {(this.state.user_permission[253].permission == 1 &&
                                    <NavLink to="/done-case" activeClassName="active">
                                        <li>Done Case</li>
                                    </NavLink>
                                )}

                                {(this.state.user_permission[255].permission == 1 &&
                                    <NavLink to="/all-case" activeClassName="active">
                                        <li className="active">All Case</li>
                                    </NavLink>
                                )}
                            </ul>
                        </div>
                        <div className="col-sm-6">
                            <ul className="float-sm-right tabaction">
                                {/* {(this.state.user_permission[257].permission == 1 &&
                                    <NavLink to="/customer-profile" activeClassName="active">
                                        <li>
                                            <img src={"../dist/img/icon/ic_tab_profile.png"} width="auto" height={30} /> Customer Profile
                                        </li>
                                    </NavLink>
                                )}

                                {(this.state.user_permission[260].permission == 1 &&
                                    <NavLink to="/customer-history" activeClassName="active">
                                        <li>
                                            <img src={"../dist/img/icon/ic_customer_History.png"} width="auto" height={30} /> Customer History
                                        </li>
                                    </NavLink>
                                )} */}

                                {/* {(this.state.user_permission[262].permission == 1 &&
                                    <NavLink to="/new-form" activeClassName="active">
                                        <li>
                                            <img src={"../dist/img/icon/ic_tab_add.png"} width="auto" height={30} /> New Form
                                        </li>
                                    </NavLink>
                                )} */}
                            </ul>
                        </div>
                    </div>)}
                    {!this.state.matches && (<div className="row">
                        <div className="col-sm-6">
                            <ul className="nav nav-pills nav-fill">
                                {/* {this.state.currentPage == '/my-case' ? <li className="nav-item">
                                    <a className="nav-link active" href="/my-case">My Case</a>
                                </li> : <li className="nav-item">
                                        <a className="nav-link" href="/my-case">My Case</a>
                                    </li>} */}
                                {this.state.currentPage == '/done-case' ? <li className="nav-item">
                                    <a className="nav-link active" href="/done-case">Done Case</a>
                                </li> : <li className="nav-item">
                                        <a className="nav-link" href="/done-case">Done Case</a>
                                    </li>}
                                {this.state.currentPage == '/all-case' ? <li className="nav-item">
                                    <a className="nav-link active" href="/all-case">All Case</a>
                                </li> : <li className="nav-item">
                                        <a className="nav-link" href="/all-case">All Case</a>
                                    </li>}
                            </ul>
                        </div>
                        <div className="col-sm-6">
                            <ul className="float-sm-right tabaction">
                                {(this.state.user_permission[257].permission == 1 &&
                                    <NavLink to="/customer-profile" activeClassName="active">
                                        <li>
                                            Customer Profile
                                        </li>
                                    </NavLink>
                                )}

                                {(this.state.user_permission[260].permission == 1 &&
                                    <NavLink to="/customer-history" activeClassName="active">
                                        <li>
                                            Customer History
                                        </li>
                                    </NavLink>
                                )}

                                {/* {(this.state.user_permission[262].permission == 1 &&
                                    <NavLink to="/new-form" activeClassName="active">
                                        <li>
                                            New Form
                                        </li>
                                    </NavLink>
                                )} */}
                            </ul>
                        </div>
                    </div>)}

                </div>{/* /.container-fluid */}
            </div>
            <Modal show={this.state.logoutIsOpen} onHide={this.closeLogoutCancel}>
                <ModalHeader>
                    <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <h2>คุณต้องการออกจากระบบใช่หรือไม่</h2>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-danger" onClick={this.closeLogoutCancel}>ยกเลิก</button>
                    <button className="btn btn-info" onClick={this.LogoutSubmit}>ตกลง</button>
                </ModalFooter>
            </Modal>
        </div>);
    }
};
export default withRouter(Header);